/**
 * The one marketing consent: tips, product news and offers by e-mail.
 *
 * The wording the visitor sees is the wording we log as proof of consent
 * (newsletter_consent_events.consent_text), so both the forms and the server
 * read it from here. Changing the text means bumping `version`: past consents
 * stay tied to the version they were given under.
 */
export const MARKETING_CONSENT = {
  version: '2026-10-01',
  text: {
    cs: 'Chci dostávat e-mailem tipy na CV a pohovory, novinky a nabídky InMyResume. Souhlas můžu kdykoli odvolat odkazem v každém e-mailu.',
    en: 'Send me tips on CVs and interviews, InMyResume news and offers by e-mail. I can withdraw this consent at any time with the link in every e-mail.',
    de: 'Ich möchte per E-Mail Tipps zu Lebenslauf und Vorstellungsgespräch sowie Neuigkeiten und Angebote von InMyResume erhalten. Diese Einwilligung kann ich jederzeit über den Link in jeder E-Mail widerrufen.',
    pl: 'Chcę otrzymywać e-mailem porady dotyczące CV i rozmów kwalifikacyjnych oraz nowości i oferty InMyResume. Zgodę mogę w każdej chwili wycofać linkiem w każdym e-mailu.',
  },
} as const

export type MarketingConsentLocale = keyof typeof MARKETING_CONSENT.text

/**
 * Where an address joined the list; stored with the consent. `cv-chat` and
 * `cv-paste` are the "e-mail me my CV" card under a generated CV;
 * `civil-service` the "Save it for later" box under a Civil Service preview.
 */
export const MARKETING_CONSENT_SOURCES = ['newsletter', 'blog', 'download', 'registration', 'profile', 'cv-chat', 'cv-paste', 'civil-service'] as const
export type MarketingConsentSource = typeof MARKETING_CONSENT_SOURCES[number]

export function marketingConsentText(locale: string | null | undefined): string {
  return locale === 'cs' || locale === 'de' || locale === 'pl' ? MARKETING_CONSENT.text[locale] : MARKETING_CONSENT.text.en
}
